import { render, staticRenderFns } from "./transfer-info.vue?vue&type=template&id=6a7b6436"
import script from "./transfer-info.vue?vue&type=script&lang=js"
export * from "./transfer-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports